var map = {
	"./default_bg_3.png": 700,
	"./default_bg_3_2.png": 701,
	"./default_bg_3_3.png": 702,
	"./default_bg_3_4.png": 703,
	"./default_bg_3_5.png": 704,
	"./default_bg_3_6.png": 705
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1858;